import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { shiftsApi } from '../api/shifts.api';

const keys = {
  list: (depId) => ['deployment', depId, 'shifts'],
};

export function useShifts(depId) {
  return useQuery({
    queryKey: keys.list(depId),
    queryFn:  () => shiftsApi.list(depId),
    enabled:  !!depId,
    staleTime: 60_000,
  });
}

export function useCreateShift(depId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => shiftsApi.create(depId, payload),
    onSuccess:  () => qc.invalidateQueries({ queryKey: keys.list(depId) }),
  });
}

export function useUpdateShift(depId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ shiftId, payload }) => shiftsApi.update(depId, shiftId, payload),
    onSuccess:  () => qc.invalidateQueries({ queryKey: keys.list(depId) }),
  });
}

export function useDeleteShift(depId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (shiftId) => shiftsApi.delete(depId, shiftId),
    onSuccess:  () => qc.invalidateQueries({ queryKey: keys.list(depId) }),
  });
}
